export default "__VITE_ASSET__DAljpvR2__"